import Modernizr from 'modernizr';
global.Modernizr = Modernizr;


Modernizr.addTest('touch', function() {
	if (Modernizr.touchevents) {
		return true;
	} else {
		return false;
	}
});
